import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminLogin } from '../../utils/api';
import './AdminLogin.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await adminLogin(identifier, password);
      localStorage.setItem('adminToken', response.access_token);
      if (response.user) {
        localStorage.setItem('adminUser', JSON.stringify(response.user));
      }
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/admin/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      if (res.ok) setForgotSent(true);
      else setError('Failed to send reset email');
    } catch {
      setError('Failed to connect');
    } finally {
      setLoading(false);
    }
  };

  if (forgotMode) {
    return (
      <div className="admin-login">
        <div className="login-container">
          <h1>Reset Password</h1>
          <p>Anyone Music Records</p>

          {forgotSent ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <p style={{ color: '#00c864', marginBottom: 12 }}>If an account exists with that email, a reset link has been sent.</p>
              <p style={{ color: '#888', fontSize: '0.82rem' }}>Check your inbox and follow the link to reset your password.</p>
              <button onClick={() => { setForgotMode(false); setForgotSent(false); }} className="btn btn-primary" style={{ marginTop: 16 }}>
                Back to Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleForgotPassword} className="login-form">
              {error && <div className="error-message">{error}</div>}
              <p style={{ color: '#888', fontSize: '0.82rem', marginBottom: 16 }}>Enter your email and we'll send you a reset link.</p>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                  placeholder="your@email.com"
                  data-testid="forgot-email"
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading} data-testid="forgot-submit">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <button type="button" onClick={() => setForgotMode(false)} style={{ display: 'block', width: '100%', background: 'none', border: 'none', color: '#888', marginTop: 12, cursor: 'pointer', fontSize: '0.82rem' }}>
                Back to Login
              </button>
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login">
      <div className="login-container">
        <h1>Admin Portal</h1>
        <p>Anyone Music Records</p>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label>Email or Username</label>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="your@email.com or username"
              required
              data-testid="login-identifier"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading} data-testid="login-submit">
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <button type="button" onClick={() => setForgotMode(true)} style={{ display: 'block', width: '100%', background: 'none', border: 'none', color: '#00ffff', marginTop: 16, cursor: 'pointer', fontSize: '0.82rem' }} data-testid="forgot-password-link">
            Forgot Password?
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
